import React, { useState } from 'react';
import { Button, DialogActions, Typography, FormControl, Grid } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import KpiLogItem from '../ObjectiveItem/EventLog/KpiLogItem.js';
import KpiEntryLogItem from '../ObjectiveItem/EventLog/KpiEntryLogItem.js';
import LoadMoreButton from '../LoadMoreButton.js';
import { EVENT_LOG } from '../../../utils/const.js';
import useKpiEventLogs from '../../../hooks/objective/eventLog/useKpiEventLogQuery.js';

const KpiEventLog = ({ onCancel, objective, kpi }) => {
  const { t } = useTranslation();
  const {  KPIS, KPI_ENTRIES }  = EVENT_LOG;
  const [ subjectType, setSubjectType ] = useState(KPIS);

  const { data, fetchNextPage, hasNextPage, isLoading, isFetching, refetch } = useKpiEventLogs({
    objective,
    kpi,
    subjectType
  });

  const handleSelectResource = (event, type) => {
    if (!type) return;
    setSubjectType(type);
    refetch();
  };

  const kpiEventLogs = data?.pages.flat() ?? [];

  const renderEventLogs = () => {
    switch (subjectType) {
      case KPIS:
        return kpiEventLogs.map((event, index) => (
          <KpiLogItem
            key={ index }
            event={ event }
          />
        ));
      case KPI_ENTRIES:
        return kpiEventLogs.map((event, index) => (
          <KpiEntryLogItem
            key={ index }
            event={ event }
          />
        ));
      default:
        return kpiEventLogs.map((event, index) => (
          <KpiLogItem
            key={ index }
            event={ event }
          />
        ));
    }
  };

  return (
    <div>
      <Typography>
        {t('objective.button.tab.eventLog')}
      </Typography>
      <FormControl component="fieldset">
        <ToggleButtonGroup
          value={ subjectType }
          exclusive
          onChange={ handleSelectResource }
          aria-label="text alignment"
        >
          <ToggleButton value={ KPIS }>
            { t('objective.eventlog.type.kpi') }
          </ToggleButton>
          <ToggleButton value={ KPI_ENTRIES }>
            { t('objective.eventlog.type.kpi_entry') }
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
      {renderEventLogs()}
      <Grid container justifyContent="center">
        <LoadMoreButton
          loading={ isFetching || isLoading }
          canLoadMore={ hasNextPage }
          loadMore={ fetchNextPage }
          loadMoreTranslation={ t('objective.eventlog.loadMoreBtn') }
          noMoreToLoadTranslation={ t('objective.eventlog.NoMoreEvents') }
        />
      </Grid>
      <DialogActions style={ { marginTop: 8 } }>
        <Button onClick={ onCancel } color='primary'>
          {t('objective.dialog.cancel')}
        </Button>
      </DialogActions>
    </div>
  );
};

export default KpiEventLog;